import * as actionTypes from '../constants/constants';

const defaultStore = {
  startDate: null,
  endDate: null,
  basketId: null,
  products: [],
  isLoadingBasketData: false,
  isShowBasket: false,
};

export default (state = defaultStore, action) => {
  switch (action.type) {
    case actionTypes.SET_BASKET_DATES_RANGE:
      return {
        ...state,
        startDate: action.payload.startDate,
        endDate: action.payload.endDate,
      };
    case actionTypes.SET_BASKET_DATA:
      return {
        ...state,
        basketId: action.payload.basketId,
        products: action.payload.products,
        isLoadingBasketData: false,
      };
    case actionTypes.SET_IS_LOADING_BASKET_DATA:
      return {
        ...state,
        isLoadingBasketData: action.payload.isLoadingBasketData,
      };
    case actionTypes.SHOW_BASKET:
      return {
        ...state,
        isShowBasket: true,
      };
    case actionTypes.HIDE_BASKET:
      return {
        ...state,
        isShowBasket: false,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/basket.js